(function () {
    $(function () {
        // при изменении в корзине, пересчитываются бонусы
        $ (document).on ('basket-response-end', event => {
            refreshBonuses()
        })
        
        $(document).on('bonus-refresh', '.js-bonus', event => {
            const offers = []
            const id = $(event.target).attr('data-offer-id')
            offers.push(id)
            refreshBonuses(offers)
        })
        
        $(document).on('bonus-children-refresh', event => {
            const $root = $(event.target)
            const offers = getBonusOffersId($root)
            refreshBonuses(offers)
        })
        
        function refreshBonuses (offersId = []) {
            // если массив не передан, пытаемся получить все на странице
            if (offersId.length === 0)
                offersId = getBonusOffersId()
            // если есть массив айдишников
            if (offersId.length > 0) {
                const $items = getFilteredItems(offersId)
                showPreloaders($items)
                $.ajax ({
                    method: 'POST',
                    url: globalData.ajaxUrls.dynamicContent,
                    data: {offers_id: offersId},
                    dataType: 'json'
                }).done (function (response) {
                    if (response.success && response.result && response.result.ProductsPrice) {
                        setBonusValues(response.result.ProductsPrice)
                    }
                })
            }
        }
        
        function getBonusOffersId ($root) {
            const offersId = []
            let $items
            if ($root instanceof jQuery && $root.length > 0) {
                $items = $root.find('.js-bonus')
            } else {
                $items = $('.js-bonus')
            }
            $items.each((index, element) => {
                const $element = $(element)
                const id = $element.attr('data-offer-id')
                if (!offersId.includes(id) && !$element.hasClass('js-bonus_no-request'))
                    offersId.push(id)
            })
            return offersId
        }
        
        function setBonusValues (offers) {
            const $items = getFilteredItems(Object.keys(offers))
            $items.each((index, element) => {
                const $element = $(element)
                const value = offers[$element.attr('data-offer-id')]['BONUS']
                if (value > 0) {
                    const html = value + '&nbsp;руб.'
                    $element.find('[data-type="value"]').html(html)
                    $element.find('.bonus-loader').remove()
                    if ($element.hasClass('bonus-badge_inactive'))
                        $element.removeClass('bonus-badge_inactive')
                    if ($element.hasClass('bonus-badge_hidden'))
                        $element.removeClass('bonus-badge_hidden')
                } else {
                    $element.addClass('bonus-badge_hidden')
                }
            })
        }
        
        function getFilteredItems (ids) {
            const $items = $('.js-bonus').filter(function(){
                const id = $(this).attr('data-offer-id')
                return id ? ids.includes(id) : null
            })
            return $items
        }
        
        function showPreloaders ($items) {
            $items.each((index, element) => {
                addLoadingAnimation($(element))
            })
        }
        
        function addLoadingAnimation ($element) {
            $element.addClass('bonus-badge_loading').append('<div class="bonus-loader"><span class="bonus-loader__animation"></span></div>')
        }
    
        // инит на загрузке
        $(document).trigger('bonus-children-refresh')
    })
}());
